import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';
import { startsWith } from 'lodash';
import { forkJoin, Observable } from 'rxjs';
import { ONBOARDING_MASTER_ROUTE } from '../../main/main.data';
import { NavigationService } from '../../navigation/navigation.service';
import { OnboardingDataStore } from '../onboarding-data.store';
import { filter, map, take } from 'rxjs/operators';

@Injectable()
export class CompletedOnboardingGuard implements CanActivate, CanActivateChild {
  constructor(
    private _onboardingDataStore: OnboardingDataStore,
    private _navigationService: NavigationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return forkJoin(
      this._onboardingDataStore.hasCompletedOnboarding(),
      this._onboardingDataStore.accountMigration$.pipe(
        filter((x) => !!x),
        take(1)
      )
    ).pipe(
      map(([hasCompletedOnboarding, ..._]) => {
        const onboardingUrl = ONBOARDING_MASTER_ROUTE;

        if (!startsWith(state.url, onboardingUrl) && !hasCompletedOnboarding) {
          this._navigationService.goToByUrl(onboardingUrl, {
            replaceUrl: true,
          });

          return false;
        }

        return true;
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(next, state);
  }
}
